<template>
  <b-modal id="attendant-modal">
    <template v-slot:modal-header="">
      <h5>العميل</h5>
    </template>

    <template v-slot:default="">
      <div class="form-group text-right">
        <label class="small">الاسم:</label>
        <input class="form-control" placeholder="الاسم" v-model="attendant.name" />
        <div v-if="!attendant.name" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <!-- <div class="form-group mt-3 text-right">
        <label class="small">رقم الجوال:</label>
        <input
          class="form-control"
          placeholder="رقم الجوال"
          type="text"
          v-model="attendant.mobile"
        />
        <div v-if="!attendant.mobile" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">البريد الإلكتروني:</label>
        <input
          class="form-control"
          placeholder="البريد الإلكتروني"
          type="email"
          v-model="attendant.email"
        />
        <div v-if="!attendant.email" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">عنوان العمل:</label>
        <textarea
          class="form-control"
          placeholder="عنوان العمل"
          v-model="attendant.workAddress"
        ></textarea>
        <div v-if="!attendant.workAddress" class="small text-red">
          الإدخال مطلوب.
        </div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">رقم الهوية:</label>
        <input
          class="form-control"
          placeholder="رقم الهوية"
          v-model="attendant.idNumber"
        />
        <div v-if="!attendant.idNumber" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">كلمة المرور:</label>
        <input
          class="form-control"
          placeholder="كلمة المرور"
          v-model="attendant.password"
          type="password"
        />
        <div v-if="!attendant.password && !selectedAttendant" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">تأكيد كلمة المرور:</label>
        <input
          class="form-control"
          placeholder="تأكيد كلمة المرور"
          v-model="attendant.password_confirmation"
          type="password"
        />
        <div v-if="!attendant.password_confirmation && !selectedAttendant" class="small text-red">الإدخال مطلوب.</div>
      </div> -->

      <div
        class="pointer d-inline-block mt-3"
        @click="$refs.idCardImage.click()"
      >
        <div class="m-auto">
          <img
            ref="idCardPreview"
            class="id-card-preview m-auto"
            :src="getImage"
            alt=""
          />
        </div>
        <span class="text-muted small">تحديث صورة الهوية</span>
        <input
          ref="idCardImage"
          type="file"
          style="display: none"
          @change="updateImage"
          accept="image/*"
        />
      </div>
    </template>

    <template v-slot:modal-footer="">
      <button type="submit" class="btn btn-primary" @click="submit">حفظ</button>
      <a
        href="#"
        class="text-muted"
        @click="$bvModal.hide('attendant-modal')"
        >إغلاق</a
      >
    </template>
  </b-modal>
</template>

<script>
import AttendantsMixin from "@/mixins/attendants";

export default {
  mixins: [AttendantsMixin],

  data() {
    return {
      attendant: {
        name: null,
        // email: null,
        mobile: null,
        workAddress: null,
        idNumber: null,
        password: null,
        password_confirmation: null,
        image: {
          link: null
        }
      },
    };
  },

  mounted() {
    this.buildAttendant();
  },

  methods: {
    buildAttendant() {
      if (this.selectedAttendant) {
        Object.keys(this.attendant).forEach((k) => (this.attendant[k] = this.selectedAttendant[k]));
        if (this.selectedAttendant.image) {
          this.attendant.image.link = this.selectedAttendant.image.link
        }

      } else {
        Object.keys(this.attendant).forEach((k) => (this.attendant[k] = null));
      }
    },
    submit() {
      this.saveAttendant(this.attendant).then((res) => {
        if (res.success) {
          // this.showSwal(res)
          if (this.$refs.idCardImage.files[0]) {
            this.saveAttendantImage(this.$refs.idCardImage.files[0]).then(
              (res2) => {
                if (res2.success) this.$bvModal.hide("attendant-modal");
              }
            );
          } else {
            this.showSwal(res);
            this.$bvModal.hide("attendant-modal");
          }
        } else {
          this.showSwal(res);
        }
      });
    },

    updateImage(e) {
      this.$refs.idCardPreview.src = URL.createObjectURL(e.target.files[0]);
    },
  },

  computed: {
    getImage () {
      return this.attendant.image ? this.attendant.image.link : require('@/assets/images/image-placeholder.png')
    }
  },

  watch: {
    selectedAttendant() {
      this.buildAttendant();
    },
  },
};
</script>